import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { get } from "../helper/helper_api";

export default function FeaturedProject() {

    const [data, setData] = useState([]);
    const [error, setError] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        get("/project/list")
            .then(json => {
                console.log('response from get project list', error);
                if (json?.statusCode == 200) {
                    setData(json?.data);
                } else {
                    setError(true);
                }
            })
            .catch(error => {
                console.log('error while getting project list', error);
            })
    }

    return (
        <section className='bottom padding-left-right featured-section'>
            <div className='header-title mb-40px'>
                {/* <div>
                    <h6 className='sub-heading wow fadeInUp'>AWESOME PORTFOLIO</h6>
                    <h2 className='heading wow fadeInUp'>Featured Projects</h2>
                </div>
                <Link to='/gallery' className='wow fadeInUp button_effect'><div className='line_border'></div>Explore All Works <i class="fa-solid fa-arrow-right"></i></Link> */}
            </div>
            <div class="marquee right">
                <div class="marquee-content">
                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-1.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-2.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-3.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-4.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-5.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-6.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-7.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-8.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-9.png')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>
                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-1.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-2.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-3.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-4.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>
                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-5.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>

                    <div class="marquee-item">
                        <img src={require('../assets/images/gallery/gallery-6.webp')} style={{ width: 350, height: 240, borderRadius: 5 }} alt="" />
                    </div>
                </div>
            </div>
        </section>
    )
}
